import { useNavigate } from 'react-router-dom';
import * as React from 'react';
import { useCirCleContext } from '../contexts/CircleContext';
import { useStepName } from './useStepName';
import { ActivityCircle } from '../consts/step';
import useLLM from './useLLM';

export const useNextStep = () => {
  const { circle, endRouter, type } = useCirCleContext();

  const LLM = useLLM();

  const stepName = useStepName();
  const nav = useNavigate();
  return React.useCallback(() => {
    if (circle) {
      if (ActivityCircle.includes(stepName)) {
        nav(`/bootguide/${LLM ? 'aiSaleBot' : 'basic'}/end`, { replace: true });
        return;
      }
      const index = circle.findIndex((item) => item === stepName);
      if (index !== -1 && index < circle.length - 1) {
        nav(`/bootguide/${type}/${circle[index + 1]}`, { replace: true });
      } else {
        nav(`${endRouter}`, { replace: true });
      }
    }
  }, [circle, nav, stepName, endRouter, type, LLM]);
};
